import { Button } from "antd";
import React from "react";
import { EditOutlined } from "@ant-design/icons";

export default function PrimaryButton({
	children,
	width,
	height,
	handleClick,
	disabled,
	icon,
	...props
}) {
	return (
		<Button
			type="primary"
			icon={icon && icon}
			disabled={disabled}
			onClick={handleClick}
			style={{
				width: width ?? "auto",
				borderRadius: "8px",
				background: "#000",
				opacity: disabled && 0.7,
				border: "none",
				fontWeight: 500,
				height: height ?? 40,
			}}
			{...props}
		>
			{children}
		</Button>
	);
}
